import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classes from './DocumentCard.module.scss'
import { ReactComponent as ModalXIcon } from '../../../assets/images/common/icons/modal-X-icon.svg'
import { ReactComponent as PdfIcon } from '../../../assets/images/common/icons/pdf-icon.svg'

const DocumentCard = ({ name, size, onRemove, withRemove = false }) => {
  const { t } = useTranslation()

  return (<div className={classes.documentContainer}>
    <div className={classes.documentTextContainer}>
      <PdfIcon />
      <span className={classes.documentText}>{t('dashboard.coach.documentCard.fileNameWithSize', { name, size })}</span></div>
    {withRemove && <button onClick={onRemove}>
      <ModalXIcon className={classes.modalXButton}/>
    </button>}
  </div> )
}

export default DocumentCard

DocumentCard.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  onRemove: PropTypes.func,
  withRemove: PropTypes.bool,
}
